/**
 * DES-TES 平台权限路由表 —— **已清空**（2026-09-14 拍板）。
 *
 * 原表 27 条：20 条指向 `@/views/mw_views/**`（真实的能源管理页面）、6 条指向
 * `@/views/system/**`（用户/角色/菜单管理）、1 条指向 `@/views/tes_views/project/analysis.vue`。
 * 也就是说除最后一条外，**没有一条是 DES-TES 自己的业务页面** —— 直接输
 * `/des_tes/project/map` 之类地址会渲染出一个可用的 MECS/MW 页面，且没有任何"开发中"提示。
 *
 * 拍板口径：DES-TES 业务未开发、暂时不需要 → **平台下所有子路由删除**，直接输地址一律
 * 回落平台入口 `/#/des_tes`（兜底规则见 `router/index.js` 的 `/des_tes/:pathMatch(.*)*`）。
 *
 * 保留本文件（而不是删文件）的原因：`store/modules/user.js#loadAsyncRoute` 用
 * `require.context` 遍历本目录，文件名参与 `_source` 平台判定；留一个空表比让文件消失更好读。
 *
 * ⚠️ 遗留死文件（未删，按 §6.7.6 同一口径不混进行为变更）：路由摘掉后
 * `views/tes_views/project/analysis.vue`（9 行，AiAnalysisWorkbench 的薄包装）已无任何引用。
 * 若将来要恢复 DES-TES 的「分析页」，把对应 route 条目加回本表即可。
 */
export default [];
